import { Typography } from '@mui/material';

function AttrLabel({ children }) {
    return (
        <Typography
            gutterBottom
            sx={{
                '&:not(:first-of-type)': {
                    paddingTop: 2,
                },
            }}
            variant="subtitle2"
        >
            {children}
        </Typography>
    );
}

export default AttrLabel;
